module.exports = __webpack_public_path__ + "img/diw_16_RecCard.b1d532d5.png";